var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg",style:(("color: " + _vm.color + "; --ai-icon-stroke-width: " + _vm.strokeWidth))},[(_vm.svgComponent)?_c(_vm.svgComponent,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }